export const formatCurrency = (value, options = {}) => {
    if(!value) {
        value = 0
    }

    if(typeof value  === 'string') {
        value = parseFloat(value.replace('$', ''))
    }

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'CAD',
        currencyDisplay: 'narrowSymbol',
        ...options,
    }).format(value)
}

// CPC rates run to fractions of a cent, so they keep up to four decimals and
// say CPC; every other payout rounds to the cent (ticket 360).
export const formatPayoutAmount = (value, type) =>
    formatCurrency(value, type === 'cpc' ? { maximumFractionDigits: 4 } : {})

export const formatPayout = (value, type) =>
    formatPayoutAmount(value, type) + (type === 'cpc' ? ' CPC' : '')
